import { atom } from 'recoil';

export const totalReviews = atom<number>({
  key: 'totalReviews',
  default: undefined,
});
